import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Label = /*#__PURE__*/_styled(Typography, true ? {
  target: "esw1ezs0"
} : {
  target: "esw1ezs0",
  label: "Label"
})(true ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQ2FyZC9MYWJlbC9MYWJlbC52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJdUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9DYXJkL0xhYmVsL0xhYmVsLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCBUeXBvZ3JhcGh5IGZyb20gJ0BzZWdtZW50L21hdGNoYS9jb21wb25lbnRzL1R5cG9ncmFwaHknXG5cbmV4cG9ydCBjb25zdCBMYWJlbCA9IHN0eWxlZChUeXBvZ3JhcGh5KWBcbiAgbWFyZ2luOiAwO1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});